import React from "react";
import { Container, Row, Col } from "reactstrap";
import TileContainer from "../containers/TitleContainer";
import "./app.css";
import giftCardImage from "../assets/giftcard.JPG";

const GiftCards = () => {
    return (
        <Container fluid>
            <TileContainer title={"Gift Vouchers"} />
            <Row className="row-m-20">
                <Col className="remove-padding">
                    <div className="textContainer">
                        <Row>
                            <Col md="8">
                                <p>
                                    We offer gift vouchers in values of £5 and £10.
                                </p>
                                <p>
                                    They can be redeemed for any purchase in the Tearoom, sandwich bar or B&B.
                                </p>
                                <p>
                                    Please call in to purchase, alternatively you can order over the phone with a
                                    £4.00 postage fee.
                                </p>

                                <h3>Gift Vouchers at White Hart, Leek</h3>
                                <p>
                                    Looking for gift vouchers in Leek, Staffordshire? White Hart gift vouchers are
                                    a flexible treat for food, drinks and stays, ideal for birthdays, anniversaries,
                                    thank-you gifts and special occasions.
                                </p>
                                <p>
                                    Our vouchers can be used for breakfast, lunch and homemade cakes in the
                                    Tearoom, fresh choices from our sandwich bar, or towards a relaxing B&B break
                                    in the town centre.
                                </p>
                                <p>
                                    If you would like help choosing voucher values, please contact our team and we
                                    will be happy to assist.
                                </p>
                            </Col>
                            <Col md="4" className="col-m-b-20" style={{ textAlign: "center" }}>
                                <img
                                    src={giftCardImage}
                                    alt="White Hart gift voucher"
                                    className="shadow-image"
                                    style={{ width: "100%", maxWidth: 260, height: "auto" }}
                                />
                            </Col>
                        </Row>
                    </div>
                </Col>
            </Row>
        </Container>
    );
};

export default GiftCards;
